import appComponents from '@/router/components';

const routes = [
    {
        path: '/market-appsum/:product/register',
        name: 'market.appsumo.product.register',
        components: {
            Content: appComponents.market_integrations.appsumo_register,
        },
        meta: {
            title: 'License Activation',
        },
    },

    {
        path: '/market-appsum/:product/license-activation/:token',
        name: 'market.appsumo.product.license.activation',
        components: {
            Content: appComponents.market_integrations.appsumo_activation,
        },
        meta: {
            title: 'License Activation',
        },
    },

    {
        path: '/admin/settings/market-integrations/webhooks',
        name: 'admin.settings.market.integrations.webhooks',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.market_integration_settings.webhooks,
        },
        meta: {
            title: 'Webhooks',
            required_auth: true,
            required_permission: true,
            permissions: ['view_schedule_commands']
        },
    },

    {
        path: '/admin/settings/market-integrations/appsumo/verify-license',
        name: 'admin.settings.market.integrations.appsumo.verify.license',
        components: {
            AuthHeader: appComponents.access_control.layouts.auth_header,
            SidebarLeft: appComponents.access_control.layouts.sidebar_left,
            Content: appComponents.market_integration_settings.appsumo_verify_license,
        },
        meta: {
            title: 'Verify License',
            required_auth: true,
            required_permission: true,
            permissions: ['view_schedule_commands']
        },
    },


];

export default routes;

